/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyExcelResultDto } from '../../models/company-excel-result-dto';

export interface ExcelControllerCompanyExcelUpload$Params {
  strategy: string;
  sourceType: string;
      body: {
'file'?: Blob;
}
}

export function excelControllerCompanyExcelUpload(http: HttpClient, rootUrl: string, params: ExcelControllerCompanyExcelUpload$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyExcelResultDto>> {
  const rb = new RequestBuilder(rootUrl, excelControllerCompanyExcelUpload.PATH, 'post');
  if (params) {
    rb.query('strategy', params.strategy, {});
    rb.query('sourceType', params.sourceType, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CompanyExcelResultDto>;
    })
  );
}

excelControllerCompanyExcelUpload.PATH = '/api/excel/company';
